import { render } from "./write-in-badge.vue?vue&type=template&id=19def6f8"
import script from "./write-in-badge.vue?vue&type=script&lang=js"
export * from "./write-in-badge.vue?vue&type=script&lang=js"

import "./write-in-badge.vue?vue&type=style&index=0&id=19def6f8&lang=css"

import exportComponent from "/Users/ars62917/Dropbox/voteomatic/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__